export const environment = {
  production: false,
  apiUrl: 'https://devorders.menutech.com',
  deviceIdKey: 'mt_service_device',
  accessTokenCookie: 'mt-staging-orders-auth',
  refreshTokenCookie: 'mt-staging-orders-refresh-token',
};
